import _defineProperty from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _toConsumableArray from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { getChildNodes as $cAn5f$getChildNodes, getLastItem as $cAn5f$getLastItem, getFirstItem as $cAn5f$getFirstItem } from "@react-stately/collections";
import { useMemo as $cAn5f$useMemo, useRef as $cAn5f$useRef, useEffect as $cAn5f$useEffect } from "react";
import { useMultipleSelectionState as $cAn5f$useMultipleSelectionState, SelectionManager as $cAn5f$SelectionManager } from "@react-stately/selection";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $62967d126f3aa823$export$4007ac09ff9c68ed(props) {
  var collection = props.collection,
    focusMode = props.focusMode;
  var selectionState = (0, $cAn5f$useMultipleSelectionState)(props);
  var disabledKeys = (0, $cAn5f$useMemo)(function () {
    return props.disabledKeys ? new Set(props.disabledKeys) : new Set();
  }, [props.disabledKeys]);
  var setFocusedKey = selectionState.setFocusedKey;
  selectionState.setFocusedKey = function (key, child) {
    // If focusMode is cell and an item is focused, focus a child cell instead.
    if (focusMode === "cell" && key != null) {
      var item = collection.getItem(key);
      if ((item === null || item === void 0 ? void 0 : item.type) === "item") {
        var _getLastItem, _getFirstItem;
        var children = (0, $cAn5f$getChildNodes)(item, collection);
        if (child === "last") key = (_getLastItem = (0, $cAn5f$getLastItem)(children)) === null || _getLastItem === void 0 ? void 0 : _getLastItem.key;else key = (_getFirstItem = (0, $cAn5f$getFirstItem)(children)) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key;
      }
    }
    setFocusedKey(key, child);
  };
  var selectionManager = (0, $cAn5f$useMemo)(function () {
    return new (0, $cAn5f$SelectionManager)(collection, selectionState);
  }, [collection, selectionState]);
  // Reset focused key if that item is deleted from the collection.
  var cachedCollection = (0, $cAn5f$useRef)(null);
  (0, $cAn5f$useEffect)(function () {
    if (selectionState.focusedKey != null && !collection.getItem(selectionState.focusedKey)) {
      var node = cachedCollection.current.getItem(selectionState.focusedKey);
      var parentNode = node.parentKey != null && (node.type === "cell" || node.type === "rowheader" || node.type === "column") ? cachedCollection.current.getItem(node.parentKey) : node;
      var cachedRows = cachedCollection.current.rows;
      var rows = collection.rows;
      var diff = cachedRows.length - rows.length;
      var index = Math.min(diff > 1 ? Math.max(parentNode.index - diff + 1, 0) : parentNode.index, rows.length - 1);
      var newRow;
      while (index >= 0) {
        if (!selectionManager.isDisabled(rows[index].key) && rows[index].type !== "headerrow") {
          newRow = rows[index];
          break;
        }
        // Find next, not disabled row.
        if (index < rows.length - 1) index++;else {
          if (index > parentNode.index) index = parentNode.index;
          index--;
        }
      }
      if (newRow) {
        var childNodes = newRow.hasChildNodes ? _toConsumableArray((0, $cAn5f$getChildNodes)(newRow, collection)) : [];
        var keyToFocus = newRow.hasChildNodes && parentNode !== node && node.index < childNodes.length ? childNodes[node.index].key : newRow.key;
        selectionState.setFocusedKey(keyToFocus);
      } else selectionState.setFocusedKey(null);
    }
    cachedCollection.current = collection;
  }, [collection, selectionManager, selectionState, selectionState.focusedKey]);
  return {
    collection: collection,
    disabledKeys: disabledKeys,
    isKeyboardNavigationDisabled: false,
    selectionManager: selectionManager
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
var $16805b1b18093c5f$export$de3fdf6493c353d = /*#__PURE__*/function (_Symbol$iterator) {
  function $16805b1b18093c5f$export$de3fdf6493c353d(opts) {
    var _this = this;
    _classCallCheck(this, $16805b1b18093c5f$export$de3fdf6493c353d);
    this.keyMap = new Map();
    this.keyMap = new Map();
    this.columnCount = opts === null || opts === void 0 ? void 0 : opts.columnCount;
    this.rows = [];
    var visit = function visit(node) {
      // If the node is the same object as the previous node for the same key,
      // we can skip this node and its children. We always visit columns though,
      // because we depend on order to build the columns array.
      var prevNode = _this.keyMap.get(node.key);
      if (opts.visitNode) node = opts.visitNode(node);
      _this.keyMap.set(node.key, node);
      var childKeys = new Set();
      var last;
      var _iterator = _createForOfIteratorHelper(node.childNodes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _child = _step.value;
          if (_child.type === "cell" && _child.parentKey == null)
            // if child is a cell parent key isn't already established by the collection, match child node to parent row
            _child.parentKey = node.key;
          childKeys.add(_child.key);
          if (last) {
            last.nextKey = _child.key;
            _child.prevKey = last.key;
          } else _child.prevKey = null;
          visit(_child);
          last = _child;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (last) last.nextKey = null;
      // Remove deleted nodes and their children from the key map
      if (prevNode) {
        var _iterator2 = _createForOfIteratorHelper(prevNode.childNodes),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var child = _step2.value;
            if (!childKeys.has(child.key)) remove(child);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    };
    var remove = function remove(node) {
      _this.keyMap.delete(node.key);
      var _iterator3 = _createForOfIteratorHelper(node.childNodes),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var child = _step3.value;
          if (_this.keyMap.get(child.key) === child) remove(child);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    };
    var last;
    opts.items.forEach(function (node, i) {
      var rowNode = _objectSpread({
        level: 0,
        key: "row-" + i,
        type: "row",
        value: undefined,
        hasChildNodes: true,
        childNodes: _toConsumableArray(node.childNodes),
        rendered: undefined,
        textValue: undefined
      }, node);
      if (last) {
        last.nextKey = rowNode.key;
        rowNode.prevKey = last.key;
      } else rowNode.prevKey = null;
      _this.rows.push(rowNode);
      visit(rowNode);
      last = rowNode;
    });
    if (last) last.nextKey = null;
  }
  _createClass($16805b1b18093c5f$export$de3fdf6493c353d, [{
    key: _Symbol$iterator,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.delegateYield(_toConsumableArray(this.rows), "t0", 1);
          case 1:
          case "end":
            return _context.stop();
        }
      }, value, this);
    })
  }, {
    key: "size",
    get: function get() {
      return _toConsumableArray(this.rows).length;
    }
  }, {
    key: "getKeys",
    value: function getKeys() {
      return this.keyMap.keys();
    }
  }, {
    key: "getKeyBefore",
    value: function getKeyBefore(key) {
      var node = this.keyMap.get(key);
      return node ? node.prevKey : null;
    }
  }, {
    key: "getKeyAfter",
    value: function getKeyAfter(key) {
      var node = this.keyMap.get(key);
      return node ? node.nextKey : null;
    }
  }, {
    key: "getFirstKey",
    value: function getFirstKey() {
      var _;
      return (_ = _toConsumableArray(this.rows)[0]) === null || _ === void 0 ? void 0 : _.key;
    }
  }, {
    key: "getLastKey",
    value: function getLastKey() {
      var _rows_;
      var rows = _toConsumableArray(this.rows);
      return (_rows_ = rows[rows.length - 1]) === null || _rows_ === void 0 ? void 0 : _rows_.key;
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      return this.keyMap.get(key);
    }
  }, {
    key: "at",
    value: function at(idx) {
      var keys = _toConsumableArray(this.getKeys());
      return this.getItem(keys[idx]);
    }
  }, {
    key: "getChildren",
    value: function getChildren(key) {
      var node = this.keyMap.get(key);
      return (node === null || node === void 0 ? void 0 : node.childNodes) || [];
    }
  }]);
  return $16805b1b18093c5f$export$de3fdf6493c353d;
}(Symbol.iterator);
export { $62967d126f3aa823$export$4007ac09ff9c68ed as useGridState, $16805b1b18093c5f$export$de3fdf6493c353d as GridCollection };